export default "__VITE_ASSET__DcCKS$eY__"